type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  as?: 'h2' | 'h3';
};

export function SectionHeading({ id, children, as = 'h2' }: SectionHeadingProps) {
  const Tag = as;

  return (
    <Tag id={id} className="group relative scroll-mt-24">
      <a
        href={`#${id}`}
        aria-label="Link to this section"
        className="absolute -left-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 text-sm text-muted-foreground transition-opacity"
      >
        #
      </a>

      {children}
    </Tag>
  );
}
